// extracted by mini-css-extract-plugin
export default {"root":"SvgCanvasCustomCursor_root__FnjIm"};